// @charset "utf-8";
/* eslint-disable */
/*
 * 点击元素外面触发事件
 * e.g. <div v-click-outside="hideSourceSelect"></div>
 *
 */

var nodeList = [];
var ctx = 'thsClickoutsideContext'; // 同命名空间的意思
// var startClick = void 0; // 同 undefind 区 别：undefind 可被重写（非严格模式下），void 0不会被重写
let startClick;


// !Vue.prototype.$isServer && on(document, 'mousedown', e => (startClick = e));

document.body.addEventListener('mousedown', function (e) {
  return startClick = e;
}, false)
document.body.addEventListener('touchstart', function (e) {
  return startClick = e;
}, false)

// !Vue.prototype.$isServer && on(document, 'mouseup', e => {
//   nodeList.forEach(node => node[ctx].documentHandler(e, startClick));
// });
document.body.addEventListener('mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
}, false)
document.body.addEventListener('touchend', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
}, false)

export default {
    bind (el, binding, vnode) {
        var id = nodeList.push(el) - 1;
        var documentHandler = function documentHandler() {
            // 获取参数 鼠标事件
            var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // dom包含 鼠标按下（or松开）的区域 则return，即不执行绑定的事件
            if (!vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
            if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
                vnode.context[el[ctx].methodName]();
            } else {
                el[ctx].bindingFn && el[ctx].bindingFn();
            }
        };
        el[ctx] = {
            id: id,
            documentHandler: documentHandler,
            methodName: binding.expression,
            bindingFn: binding.value
        };
    },
    update (el, binding) {
        el[ctx].methodName = binding.expression;
        el[ctx].bindingFn = binding.value;
    },
    unbind (el) {
        var len = nodeList.length;

        for (var i = 0; i < len; i++) {
            if (nodeList[i][ctx].id === el[ctx].id) {
                nodeList.splice(i, 1);
                break;
            }
        }
    }


  /*  // 这种当然也行，上面的方法考虑更全面
    bind (el, binding, vnode) {
        var id = nodeList.push(el) - 1;
        // el.event
        var documentHandler = function (event) {
            if (el !== event.target && !el.contains(event.target)) {
                vnode.context[binding.expression](event)
            }
        }
        el[ctx] = {
            id: id,
            documentHandler: documentHandler,
            methodName: binding.expression,
            bindingFn: binding.value
        };
        // el.addEventListener('click', el.stopPropagation())
        // document.body.addEventListener('click', el.event)
    },
    unbind (el) {
        // el.removeEventListener('click', el.stopPropagation())
        // document.body.removeEventListener('click', el.event)
    }
*/
}



// WEBPACK FOOTER //
// ./src/lib/clickOutside.js